import { plainToInstance } from 'class-transformer'

import MessageEditorWithMediaData from '../../types'
import { IMessageSettings } from './types'

class MessageSettingsFields implements IMessageSettings {
  pin!: boolean
  disable_link_preview!: boolean
  disable_notify!: boolean
  remove_previous!: boolean
  protect_content!: boolean
  remove_after!: number
  send_after!: number
  text!: string
  topics?: Array<number>
}

export default class SettingsMessageManager {
  fields: IMessageSettings

  /** Поле используется для отображения свича (disable_link_preview) в настройках сообщения, назначается при мутации медиа файлов */
  havePreviewMedia = false

  constructor(message: MessageEditorWithMediaData) {
    this.fields = plainToInstance(MessageSettingsFields, message)
  }

  setFieldValue<T extends keyof IMessageSettings>(field: T, value: IMessageSettings[T]): void {
    this.fields[field] = value
    this.updateMessageSettings()
  }

  addUpdateMessageSettingsListener(fn: (settings: IMessageSettings) => void): void {
    this.onUpdateSettings = () => fn(this.fields)
  }

  updateMessageSettings(): void {
    if (this.onUpdateSettings) {
      this.onUpdateSettings()
    }
  }

  onUpdateSettings: null | (() => void) = null
}
